import { c as _c } from "react/compiler-runtime";
import type { DocumentUploadSettings } from '@onefootprint/request-types/dashboard';
import { CodeInline } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import Item from '@/playbook-builder/components/item';
import Section from '@/playbook-builder/components/section';
import SubSection from '@/playbook-builder/components/sub-section';
import type { CollectDocumentNodeProps } from '@/playbook-builder/playbook-builder.types';
type AdditionalDocumentsViewProps = {
  node: CollectDocumentNodeProps;
};
const AdditionalDocumentsView = t0 => {
  const $ = _c(25);
  const {
    node
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectDocument.additionalDocuments"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  const t2 = node.data.documents;
  let T0;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== node.data.documents || $[2] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const customDocuments = t2.filter(_temp);
      let t7;
      if ($[8] !== node.data.documents) {
        t7 = node.data.documents.filter(_temp2);
        $[8] = node.data.documents;
        $[9] = t7;
      } else {
        t7 = $[9];
      }
      const proofOfAddress = t7;
      let t8;
      if ($[10] !== node.data.documents) {
        t8 = node.data.documents.filter(_temp3);
        $[10] = node.data.documents;
        $[11] = t8;
      } else {
        t8 = $[11];
      }
      const proofOfSsn = t8;
      let t9;
      if ($[12] !== t) {
        t9 = uploadSettings => {
          if (uploadSettings === "prefer_upload") {
            return t(_temp4);
          }
          if (uploadSettings === "capture_only_on_mobile") {
            return t(_temp5);
          }
          return t(_temp6);
        };
        $[12] = t;
        $[13] = t9;
      } else {
        t9 = $[13];
      }
      const renderUploadSettings = t9;
      if (!customDocuments.length && !proofOfAddress.length && !proofOfSsn.length) {
        t6 = null;
        break bb0;
      }
      T0 = Section;
      if ($[14] !== t) {
        t3 = t(_temp7);
        $[14] = t;
        $[15] = t3;
      } else {
        t3 = $[15];
      }
      if ($[16] !== proofOfAddress.length || $[17] !== proofOfSsn || $[18] !== t) {
        t4 = proofOfAddress.length > 0 || proofOfSsn.length > 0 ? <SubSection title={t(_temp8)}><div className="flex flex-col gap-2"><Item label={t(_temp9)} value={proofOfAddress.length > 0} /><Item label={t(_temp10)} value={proofOfSsn.length > 0} /></div></SubSection> : null;
        $[16] = proofOfAddress.length;
        $[17] = proofOfSsn;
        $[18] = t;
        $[19] = t4;
      } else {
        t4 = $[19];
      }
      t5 = customDocuments.length > 0 ? <SubSection title={t(_temp11)}><div className="flex flex-col gap-4">{customDocuments.map(t10 => {
            const {
              data
            } = t10;
            return <div key={data.identifier} className="flex flex-col gap-4 not-first:border-t not-first:border-dashed not-first:border-primary not-first:pt-4"><Item label={t(_temp12)} value={<div className="text-body-2">{data.name}</div>} /><Item label={t(_temp13)} value={<CodeInline size="compact">{data.identifier}</CodeInline>} />{data.description && <Item label={t(_temp14)} value={<div className="text-body-2">{data.description}</div>} />}<Item label={t(_temp15)} value={<div className="text-body-2">{renderUploadSettings(data.uploadSettings)}</div>} /></div>;
          })}</div></SubSection> : null;
    }
    $[1] = node.data.documents;
    $[2] = t;
    $[3] = T0;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    T0 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[20] !== T0 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5) {
    t7 = <T0 title={t3}>{t4}{t5}</T0>;
    $[20] = T0;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t7;
  } else {
    t7 = $[24];
  }
  return t7;
};
export default AdditionalDocumentsView;
function _temp(doc) {
  return doc.kind === "custom";
}
function _temp2(doc_0) {
  return doc_0.kind === "proof_of_address";
}
function _temp3(doc_1) {
  return doc_1.kind === "proof_of_ssn";
}
function _temp4($) {
  return $.custom.upload;
}
function _temp5($_0) {
  return $_0.custom.captureOnlyMobile;
}
function _temp6($_1) {
  return $_1.custom.capture;
}
function _temp7($_2) {
  return $_2.title;
}
function _temp8($_3) {
  return $_3.standard.view.title;
}
function _temp9($_4) {
  return $_4.standard.view.proofOfAddress;
}
function _temp10($_5) {
  return $_5.standard.view.proofOfSsn;
}
function _temp11($_6) {
  return $_6.custom.title;
}
function _temp12($_7) {
  return $_7.custom.documentLabel;
}
function _temp13($_8) {
  return $_8.custom.identifier;
}
function _temp14($_9) {
  return $_9.custom.description;
}
function _temp15($_10) {
  return $_10.custom.preferredMethod;
}